import type { ReactNode } from 'react';
import { goBack, Link } from '../lib/router';
import { IconButton, cx } from './ui/primitives';
import styles from './layout.module.css';

/** Scrollable page container that reserves space for nav + mini-player. */
export function Page({ children, className, flush }: { children: ReactNode; className?: string; flush?: boolean }) {
  return <div className={cx(styles.page, flush && styles.flush, className)}>{children}</div>;
}

export function PageHeader({ title, back = true, actions, transparent, fallback = '/' }: { title?: ReactNode; back?: boolean; actions?: ReactNode; transparent?: boolean; fallback?: string }) {
  return (
    <header className={cx(styles.header, transparent && styles.headerTransparent)}>
      <div className={styles.headerSide}>{back && <IconButton icon="back" label="Terug" onClick={() => goBack(fallback)} />}</div>
      <h1 className={styles.headerTitle}>{title}</h1>
      <div className={cx(styles.headerSide, styles.headerActions)}>{actions}</div>
    </header>
  );
}

export function Section({ title, to, children, action }: { title: string; to?: string; children: ReactNode; action?: ReactNode }) {
  return (
    <section className={styles.section}>
      <div className={styles.sectionHead}>
        <h2>{title}</h2>
        {to ? (
          <Link to={to} className={styles.sectionLink}>
            Alles
          </Link>
        ) : (
          action
        )}
      </div>
      {children}
    </section>
  );
}

export function Shelf({ children }: { children: ReactNode }) {
  return <div className={styles.shelf}>{children}</div>;
}
